import React from "react";
import { ResumoResponse } from "../types";
import { TrendingUp, Award, Box } from "lucide-react";

interface AnalyticsPanelProps {
  resumo: ResumoResponse | null;
}

export const AnalyticsPanel: React.FC<AnalyticsPanelProps> = ({ resumo }) => {
  if (!resumo || resumo.resumoCategoriaMarca.length === 0) return null;

  const formatMoney = (val: number | null) => {
    if (val === null || val === undefined) return "N/D";
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(val);
  };

  const topCategorias = resumo.resumoPorCategoria.slice(0, 5);
  const topMarcas = resumo.resumoCategoriaMarca.slice(0, 6);

  return (
    <section
      style={{
        background: "var(--bg-secondary)",
        border: "1px solid var(--border-color)",
        borderRadius: "16px",
        padding: "20px 24px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <TrendingUp size={20} color="#3b82f6" />
        <h2 style={{ fontSize: "1.1rem", fontWeight: 700 }}>
          Inteligência do Edital ({resumo.editalId})
        </h2>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "20px" }}>
        {/* Top Categorias */}
        <div>
          <h3 style={{ fontSize: "0.85rem", fontWeight: 700, color: "var(--text-muted)", marginBottom: "10px", display: "flex", alignItems: "center", gap: "6px" }}>
            <Box size={16} color="#60a5fa" /> Principais Categorias por Unidades
          </h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {topCategorias.map((cat, idx) => (
              <div
                key={idx}
                style={{
                  background: "var(--bg-card)",
                  padding: "10px 14px",
                  borderRadius: "8px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "0.85rem",
                }}
              >
                <span style={{ fontWeight: 600 }}>{cat.categoria}</span>
                <span style={{ fontFamily: "var(--font-mono)", color: "#34d399", fontWeight: 700 }}>
                  {cat.total_unidades} un.
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Top Marcas e Custo Médio */}
        <div>
          <h3 style={{ fontSize: "0.85rem", fontWeight: 700, color: "var(--text-muted)", marginBottom: "10px", display: "flex", alignItems: "center", gap: "6px" }}>
            <Award size={16} color="#f59e0b" /> Marcas em Destaque & Custo Médio
          </h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {topMarcas.map((item, idx) => (
              <div
                key={idx}
                style={{
                  background: "var(--bg-card)",
                  padding: "10px 14px",
                  borderRadius: "8px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "0.85rem",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span style={{ fontWeight: 600 }}>{item.marca}</span>
                  <span style={{ fontSize: "0.75rem", color: "var(--text-dim)" }}>({item.categoria})</span>
                </div>
                <div style={{ textAlign: "right" }}>
                  <span style={{ fontFamily: "var(--font-mono)", color: "#38bdf8", fontWeight: 700 }}>
                    {formatMoney(item.custo_medio_estimado)}
                  </span>
                  <span style={{ fontSize: "0.75rem", color: "var(--text-muted)", marginLeft: "8px" }}>
                    ({item.total_unidades} un.)
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
